/* eslint-disable import/prefer-default-export */
import headers from "app/requests/headers";

export const get = (uid) => (
  fetch(`/api/newsletters/${uid}`, {
    headers: headers(),
    method: "GET"
  }).then((response) => response.json())
);
